import { Typography, styled } from "@mui/material";
import { theme } from "../../Themes/Themes";
import "./Dialog.css";

interface DialogButtonProps {
  onClick: () => void;
  text: string;
  label?: string;
  style?: React.CSSProperties;
  /** Additional inline styles applied directly to the inner clickable div ( `.Button.DialogButton` )  */
  buttonStyle?: React.CSSProperties;
  /** Whether this button is currently selected (renders with the same look as the hover state). Default: false */
  selected?: boolean;
  fontSize?: string | number;
  "data-testid"?: string;
  id?: string;
}

const SmallLabel = styled(Typography)({
  position: "absolute",
  top: "3px",
  fontSize: "12px",
  color: theme.custom.darkerGrey,
  marginBottom: "4px",
  textAlign: "center",
});

const ButtonText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "customSize",
})<{ customSize?: string | number }>(({ customSize }) => ({
  fontSize: customSize || "15px",
  fontWeight: "Normal",
  color: theme.palette.primary.main,
  whiteSpace: "nowrap",
}));

const ButtonWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

export default function DialogButton({
  onClick,
  text,
  label,
  style,
  /** Additional inline styles applied directly to the inner clickable div ( `.Button.DialogButton` )  */
  buttonStyle,
  /** Whether this button is currently selected (renders with the same look as the hover state). Default: false */
  selected = false,
  fontSize,
  "data-testid": testId,
  id,
}: DialogButtonProps) {
  // Merge styles depending on selected state for the inner clickable element
  const innerButtonSelectedStyles: React.CSSProperties = selected
    ? {
        backgroundColor: theme.custom.pink,
        borderColor: theme.custom.pink,
      }
    : {};

  const textSelectedStyles: React.CSSProperties = selected
    ? {
        color: "white",
        fontWeight: 700,
      }
    : {};

  return (
    <ButtonWrapper style={style}>
      {label && <SmallLabel>{label}</SmallLabel>}
      <div
        className="Button DialogButton"
        onClick={onClick}
        data-testid={testId}
        id={id}
        style={{ ...buttonStyle, ...innerButtonSelectedStyles }}
      >
        <ButtonText customSize={fontSize} style={textSelectedStyles}>
          {text}
        </ButtonText>
      </div>
    </ButtonWrapper>
  );
}
